import React, { useState } from 'react'
import './styles.scss'

export const Box = ({
  children,
  title
}: {
  children: JSX.Element | JSX.Element[]
  title?: string
}) => {
  const [isopen, setOpen] = useState(false)
  return (
    <div className={'Box ' + (isopen ? 'open' : '')}>
      {title && (
        <h5 className='title' onClick={() => setOpen(!isopen)}>
          {title}
          <i className='caret down icon' />
        </h5>
      )}
      <div className='content'><div className='pad'>{children}</div></div>
    </div>
  )
}
